// Dropped by the reverse proxy when it recovers from a torn-down feature
// branch, so the app can tell the developer why they are back on develop.
const staleFeatureBranchCookieName = 'merch-fb-cleared';

export default staleFeatureBranchCookieName;
